import moment from 'moment';

export const playbillKeys = {
  all: ['playbills'] as const,
  mapChannels: (channelIds: string[], date: Date) =>
    [...playbillKeys.all, channelIds.join('-'), moment(date).format('YYYY-MM-DD') + 'map'] as const,
  channels: (channelIds: string[], date: Date) =>
    [...playbillKeys.all, channelIds.join('-'), moment(date).format('YYYY-MM-DD')] as const,
  channelsPreNext: (channelIds: string[], date: Date, pre: number, next: number) =>
    [...playbillKeys.all, channelIds.join('-') + pre + next, moment(date).format('YYYY-MM-DD')] as const,
  channelsBatched: (channelIds: string[], date: Date) =>
    [...playbillKeys.all, channelIds.join('-') + 'batched', moment(date).format('YYYY-MM-DD')] as const,
};
